
import {gsap, Power4, TweenMax} from 'gsap'
import { ScrollToPlugin} from 'gsap/ScrollToPlugin'
gsap.registerPlugin(ScrollToPlugin);

document.addEventListener('DOMContentLoaded', () => {
	let backToTop = document.querySelectorAll('.js-back-to-top')
	backToTop.forEach(i => {
		i.addEventListener('click', () => {
			gsap.to(window, {duration: 2, scrollTo: {y: 0}, ease: Power4.easeOut})
		})
	})
	let scrollToNext = document.querySelectorAll('.js-scroll-to-next')
	scrollToNext.forEach(i => {
		i.addEventListener('click', () => {
			gsap.to(window, {duration: 2, scrollTo: {y: i, offsetY: -120}, ease: Power4.easeOut})
		})
	})
})

